// This icon file is generated by scripts/icons/build.ts
// DON NOT EDIT IT MANUALLY

/* eslint-disable */
// @ts-ignore

import * as React from 'react';
import factory from '../factory';

export default factory(
  'ChevronDown',
  'chevron-down',
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    ></path>
  </svg>
);
